/**
 * Fetches the tickets of the logged-in user from the Eventive API.
 *
 * @param {string} userToken - The token of the authenticated user.
 * @param {string} eventBucketId - The ID of the event bucket to filter tickets by.
 * @param {string} apiKey - The API key required for Eventive API access.
 * @returns {Promise<object>} - A Promise that resolves to the user's ticket data.
 *
 * Example usage:
 * fetchSelfTickets(userToken, eventBucketId, apiKey)
 *   .then(tickets => console.log('User tickets:', tickets))
 *   .catch(error => console.error('Error fetching tickets:', error));
 *
 * This function uses the Fetch API to send a GET request to the Eventive API,
 * requesting tickets for the specified event bucket associated with the user.
 * The 'conditions' parameter is URL-encoded to ensure proper formatting.
 *
 * The API key is base64-encoded in the Authorization header.
 */
export function fetchSelfTickets(userToken, eventBucketId, apiKey) {
  const conditions = {
    event_bucket: eventBucketId
  };

  const apiUrl = `https://api.eventive.org/people/self/tickets?token=${userToken}&conditions=${encodeURIComponent(JSON.stringify(conditions))}`;

  return fetch(apiUrl, {
    method: "GET",
    headers: {
      "Authorization": `Basic ${btoa(apiKey)}`,
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        console.trace('fetchSelfTickets: Failed to fetch tickets: ' + response.statusText);
        return null;
      }
      return response.json();
    })
    .then((data) => {
      // console.trace('User tickets:', data);
      return data;
    })
    .catch((error) => {
      console.error('fetchSelfTickets: Error fetching tickets:', error);
      return null;
    });
}

